/* GC3H Online Canteen — Meal Credit Voucher (design + PDF/email helpers) */
import { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";

const STYLE_ID = "gc3h-voucher-styles";
const css = `
@import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,800&family=Caveat:wght@600;700&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@500;700&display=swap');

.gc3h-v{--ink:#211C18;--paprika:#C53D24;--paprika-deep:#8E2A18;--gold:#F4C46A;--gold-soft:#FCEBC8;--herb:#4F7A3A;--cream:#FBF5EC;--cream-2:#F3E7D2;
  position:relative;display:flex;width:760px;max-width:100%;border-radius:20px;overflow:hidden;font-family:'Inter',system-ui,sans-serif;color:var(--ink);
  background:var(--cream);box-shadow:0 24px 50px -22px rgba(0,0,0,.45),0 0 0 1px rgba(0,0,0,.12);}
.gc3h-v .gc3h-main{flex:1;position:relative;overflow:hidden;padding:34px 36px 32px;min-height:340px;
  display:flex;flex-direction:column;justify-content:space-between;color:var(--gold-soft);
  background:radial-gradient(140% 120% at 0% 0%,var(--paprika) 0%,var(--paprika-deep) 78%);}
.gc3h-v .gc3h-main::before{content:"";position:absolute;inset:0;opacity:.07;pointer-events:none;background-size:60px 60px;
  background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 60 60'><g fill='none' stroke='%23FBF5EC' stroke-width='1.4'><circle cx='30' cy='30' r='9'/><path d='M12 12v10M12 12c-2 0-2 2-2 4s0 4 2 4M48 12v22'/></g></svg>");}
.gc3h-v .gc3h-brand{display:flex;align-items:center;gap:12px;position:relative;}
.gc3h-v .gc3h-badge{width:46px;height:46px;border-radius:50%;flex:none;border:2px solid var(--gold);display:grid;place-items:center;background:rgba(0,0,0,.12);}
.gc3h-v .gc3h-badge svg{width:24px;height:24px;}
.gc3h-v .gc3h-name{font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:19px;line-height:1;color:#fff;letter-spacing:-.01em;}
.gc3h-v .gc3h-sub{font-size:10.5px;letter-spacing:.22em;text-transform:uppercase;color:var(--gold);margin-top:4px;}
.gc3h-v .gc3h-valblock{display:flex;flex-direction:column;}
.gc3h-v .gc3h-eyebrow{font-size:11px;letter-spacing:.26em;text-transform:uppercase;color:var(--gold);font-weight:700;margin:0 0 8px;}
.gc3h-v .gc3h-occasion{font-family:'Caveat',cursive;font-weight:700;font-size:30px;line-height:1;color:var(--gold);margin:0 0 10px;}
.gc3h-v .gc3h-value{font-family:'Bricolage Grotesque',sans-serif;font-weight:800;color:#fff;line-height:1.04;letter-spacing:-.015em;
  font-size:70px;display:inline-flex;align-items:flex-start;gap:8px;margin:0;padding:0;}
.gc3h-v .gc3h-cur{font-size:.36em;color:var(--gold);font-weight:700;line-height:1;margin-top:.55em;}
.gc3h-v .gc3h-value-sub{font-size:11.5px;color:rgba(252,235,200,.78);margin-top:12px;letter-spacing:.015em;}
.gc3h-v .gc3h-msg{font-family:'Caveat',cursive;font-weight:700;font-size:24px;line-height:1.25;color:#fff;
  margin-top:18px;padding:6px 0 6px 14px;border-left:3px solid var(--gold);max-width:94%;}
.gc3h-v .gc3h-meta{display:flex;gap:26px;position:relative;flex-wrap:wrap;}
.gc3h-v .gc3h-k{font-size:9.5px;letter-spacing:.18em;text-transform:uppercase;color:var(--gold);opacity:.85;margin-bottom:3px;}
.gc3h-v .gc3h-mv{font-family:'JetBrains Mono',monospace;font-size:14px;color:#fff;font-weight:500;}
.gc3h-v .gc3h-stub{width:248px;flex:none;background:var(--cream);padding:26px 22px;text-align:center;
  display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;position:relative;}
.gc3h-v .gc3h-scan{font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:var(--herb);font-weight:700;}
.gc3h-v .gc3h-qr{background:#fff;padding:11px;border-radius:14px;border:2px solid var(--ink);box-shadow:0 6px 0 rgba(33,28,24,.12);line-height:0;}
.gc3h-v .gc3h-helper{font-size:11.5px;color:rgba(33,28,24,.6);line-height:1.4;max-width:170px;}
.gc3h-v .gc3h-serial{font-family:'JetBrains Mono',monospace;font-weight:700;font-size:13px;color:var(--ink);
  background:var(--cream-2);border:1px dashed rgba(33,28,24,.35);border-radius:8px;padding:7px 10px;letter-spacing:.04em;}
.gc3h-v .gc3h-perf{position:relative;width:0;border-left:2px dashed rgba(33,28,24,.3);margin-left:-1px;z-index:3;}
.gc3h-v .gc3h-perf::before,.gc3h-v .gc3h-perf::after{content:"";position:absolute;width:22px;height:22px;border-radius:50%;background:#fff;left:-11px;}
.gc3h-v .gc3h-perf::before{top:-11px;}
.gc3h-v .gc3h-perf::after{bottom:-11px;}
@media (max-width:640px){
  .gc3h-v{flex-direction:column;}
  .gc3h-v .gc3h-stub{width:100%;}
  .gc3h-v .gc3h-value{font-size:54px;}
  .gc3h-v .gc3h-perf{width:auto;height:0;border-left:none;border-top:2px dashed rgba(33,28,24,.3);margin:0;}
  .gc3h-v .gc3h-perf::before{left:-11px;top:-11px;}
  .gc3h-v .gc3h-perf::after{left:auto;right:-11px;top:-11px;bottom:auto;}
}
`;

export function useVoucherStyles() {
  useEffect(() => {
    if (document.getElementById(STYLE_ID)) return;
    const el = document.createElement("style");
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }, []);
}

export function defaultLoginUrl() {
  return `${window.location.origin}/auth`;
}

function amountInWords(n) {
  const ones = ["zero","one","two","three","four","five","six","seven","eight","nine","ten","eleven","twelve","thirteen","fourteen","fifteen","sixteen","seventeen","eighteen","nineteen"];
  const tens = ["","","twenty","thirty","forty","fifty","sixty","seventy","eighty","ninety"];
  const seg = (x) => {
    if (x === 0) return "";
    if (x < 20) return ones[x];
    if (x < 100) return tens[Math.floor(x/10)] + (x%10 ? "-" + ones[x%10] : "");
    return ones[Math.floor(x/100)] + " hundred" + (x%100 ? " and " + seg(x%100) : "");
  };
  if (n === 0) return "Zero";
  const th = Math.floor(n/1000), rest = n%1000;
  let out = "";
  if (th) out += seg(th) + " thousand" + (rest ? (rest < 100 ? " and " : " ") : "");
  out += seg(rest);
  return out.charAt(0).toUpperCase() + out.slice(1);
}

function formatExpiry(expiry) {
  if (!expiry) return "No expiry";
  try {
    const d = new Date(expiry);
    if (isNaN(d.getTime())) return expiry;
    return d.toLocaleDateString("en-ZA", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return expiry; }
}

/* Occasion themes — override the card's main colours + labels */
export const VOUCHER_THEMES = {
  classic:         { label: 'Classic',         occasion: '',                   sub: 'Meal Credit Voucher',   main: '#C53D24', deep: '#8E2A18' },
  birthday:        { label: 'Birthday',        occasion: 'Happy Birthday!',    sub: 'Birthday Gift Voucher', main: '#7C3AED', deep: '#4C1D95' },
  thank_you:       { label: 'Thank You',       occasion: 'Thank you!',         sub: 'Thank-You Voucher',     main: '#2F7A4D', deep: '#1C5133' },
  congratulations: { label: 'Congratulations', occasion: 'Congratulations!',   sub: 'Celebration Voucher',   main: '#1D4ED8', deep: '#172E80' },
  festive:         { label: 'Festive',         occasion: "Season's Greetings", sub: 'Festive Gift Voucher',  main: '#B01E36', deep: '#701226' },
  get_well:        { label: 'Get Well',        occasion: 'Get well soon',      sub: 'Get-Well Voucher',      main: '#0E7490', deep: '#155E63' },
};

export default function VoucherCard({ value = 0, code = "", expiry = "", message = "", theme = "classic", loginUrl }) {
  useVoucherStyles();
  const t = VOUCHER_THEMES[theme] || VOUCHER_THEMES.classic;
  const url = loginUrl || defaultLoginUrl();
  const sep = url.includes("?") ? "&" : "?";
  const qrTarget = `${url}${sep}ref=voucher&code=${encodeURIComponent(code)}`;
  const numericValue = Number(value) || 0;

  return (
    <div className="gc3h-v" data-testid="voucher-card" style={{ "--paprika": t.main, "--paprika-deep": t.deep }}>
      <div className="gc3h-main">
        <div className="gc3h-brand">
          <div className="gc3h-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="#F4C46A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 3v7a2 2 0 0 0 2 2 2 2 0 0 0 2-2V3" />
              <path d="M8 12v9" />
              <path d="M16 3c-1.5 0-2.5 2-2.5 4.5S15 12 16 12s2.5-2 2.5-4.5S17.5 3 16 3z" />
              <path d="M16 12v9" />
            </svg>
          </div>
          <div>
            <div className="gc3h-name">GC3H Online Canteen</div>
            <div className="gc3h-sub">{t.sub}</div>
          </div>
        </div>

        <div className="gc3h-valblock">
          {t.occasion ? <div className="gc3h-occasion">{t.occasion}</div> : null}
          <div className="gc3h-eyebrow">Credit value</div>
          <div className="gc3h-value"><span className="gc3h-cur">R</span><span>{numericValue.toLocaleString("en-ZA")}</span></div>
          <div className="gc3h-value-sub">{amountInWords(numericValue)} rand · South African Rand</div>
          {message ? <div className="gc3h-msg">{message}</div> : null}
        </div>

        <div className="gc3h-meta">
          <div>
            <div className="gc3h-k">Voucher No.</div>
            <div className="gc3h-mv">{code}</div>
          </div>
          <div>
            <div className="gc3h-k">Valid until</div>
            <div className="gc3h-mv">{formatExpiry(expiry)}</div>
          </div>
        </div>
      </div>

      <div className="gc3h-perf" />

      <div className="gc3h-stub">
        <div className="gc3h-scan">Scan to redeem</div>
        <div className="gc3h-qr">
          <QRCodeSVG value={qrTarget} size={150} level="M" fgColor="#211C18" bgColor="#ffffff" />
        </div>
        <div className="gc3h-helper">Opens the GC3H Online Canteen login &amp; sign-up page</div>
        <div className="gc3h-serial">{code}</div>
      </div>
    </div>
  );
}

/* ---------------- PDF helpers ---------------- */
function ensureStyles() {
  if (document.getElementById(STYLE_ID)) return;
  const el = document.createElement("style");
  el.id = STYLE_ID;
  el.textContent = css;
  document.head.appendChild(el);
}

async function buildVouchersPDF(vouchers, loginUrl) {
  const { default: jsPDF } = await import("jspdf");
  const html2canvas = (await import("html2canvas")).default;
  const { createRoot } = await import("react-dom/client");
  const url = loginUrl || defaultLoginUrl();

  ensureStyles();
  const holder = document.createElement("div");
  holder.style.cssText = "position:fixed;left:-99999px;top:0;";
  document.body.appendChild(holder);

  try { await document.fonts.ready; } catch { /* ignore */ }

  const pdf = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  for (let i = 0; i < vouchers.length; i++) {
    const node = document.createElement("div");
    holder.appendChild(node);
    const root = createRoot(node);
    root.render(<VoucherCard {...vouchers[i]} loginUrl={url} />);
    await new Promise((r) => setTimeout(r, 220));

    const canvas = await html2canvas(node.firstChild, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
    const img = canvas.toDataURL("image/jpeg", 0.92);

    const margin = 40;
    const maxW = pageW - margin * 2;
    const maxH = pageH - margin * 2;
    const ratio = Math.min(maxW / canvas.width, maxH / canvas.height);
    const w = canvas.width * ratio;
    const h = canvas.height * ratio;

    if (i > 0) pdf.addPage();
    pdf.addImage(img, "JPEG", (pageW - w) / 2, (pageH - h) / 2, w, h);

    root.unmount();
    node.remove();
  }

  document.body.removeChild(holder);
  return pdf;
}

export async function exportVouchersPDF(vouchers, loginUrl, filename = "gc3h-vouchers.pdf") {
  const pdf = await buildVouchersPDF(vouchers, loginUrl);
  pdf.save(filename);
}

export async function downloadSingleVoucherPDF(voucher, loginUrl, filename) {
  const name = filename || `gc3h-voucher-${voucher.code || "card"}.pdf`;
  await exportVouchersPDF([voucher], loginUrl, name);
}

export async function vouchersPdfBase64(vouchers, loginUrl) {
  const pdf = await buildVouchersPDF(vouchers, loginUrl);
  // returns a data URI string: "data:application/pdf;filename=...;base64,XXXX"
  const dataUri = pdf.output("datauristring");
  return dataUri.includes(",") ? dataUri.split(",")[1] : dataUri;
}
